export const APPLY_LIST_PAGE_PATH = '/apply/list'
